// Function is explicitly desired here
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function debounce<T extends Function>(callback: T, delay = 300): T {
  let timeout: number | null = null;
  // any is explicitly desired here to allow for a generic callback
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fun = (...args: any) => {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => callback(...args), delay) as unknown as number;
  };
  return fun as unknown as T;
}

export default debounce;
